
















import { Component, Prop, Vue } from "vue-property-decorator";
import Liff from "@line/liff";
import { FinanceType, TransactionType } from "@/enums/enums";
import { GetDocumentName } from "@/helper/shareHelper";

@Component
export default class ModalCanNotCreateDocument extends Vue {
  @Prop({ default: TransactionType.None }) readonly transactionType!: TransactionType;
  @Prop({ default: FinanceType.None }) readonly financeType!: FinanceType;

  public Hide() {
    Liff.closeWindow();
  }

  public GetDocumentName() {
    return GetDocumentName(this.transactionType, this.financeType);
  }
}
